<template>
  <div id="award-criteria-mapping">
    <v-card class="premium-checkout-card">
      <!-- Checkout Banner Header -->
      <div class="checkout-banner">
        <div class="hero-glow-effect"></div>
        <v-icon class="deco-icon icon-card" color="rgba(255, 255, 255, 0.08)"
          >mdi-link-variant</v-icon
        >
        <v-row class="ma-0 align-center relative-content">
          <v-col cols="10" class="text-left pa-0">
            <div class="banner-title d-flex align-center">
              <v-icon dark class="mr-2 pulse-animation"
                >mdi-trophy-outline</v-icon
              >
              Map Criteria - {{ AwardTypeTitle }}
            </div>
            <p class="banner-subtitle">
              Select and assign target criteria to this award type.
            </p>
          </v-col>
          <v-col cols="2" class="text-right pa-0">
            <v-btn icon dark @click="closePrompt">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <v-card-text class="pt-4 card-content-area">
        <!-- Mapping Controls Bar -->
        <div class="d-flex justify-content-between align-center mb-4 flex-wrap">
          <div class="d-flex align-center">
            <v-icon color="#1565C0" class="mr-2">mdi-database</v-icon>
            <span class="result-count-text"
              >Mapped Criteria ({{ mappedCriteriaList.length }})</span
            >
          </div>
          <div>
            <v-btn
              @click.prevent="showDropdownSection = !showDropdownSection"
              color="primary"
              rounded
              small
              class="font-weight-bold filter-btn btn-search white--text"
            >
              <v-icon left>{{
                showDropdownSection ? "mdi-minus" : "mdi-plus"
              }}</v-icon>
              {{
                showDropdownSection ? "Hide Mapping Panel" : "Map New Criteria"
              }}
            </v-btn>
          </div>
        </div>

        <v-expand-transition>
          <div
            v-show="showDropdownSection"
            class="mb-4 pa-4 grey lighten-4 rounded"
            style="border: 1px solid rgba(21, 101, 192, 0.1)"
          >
            <v-row wrap align="center">
              <v-col cols="12" sm="8" md="8">
                <label class="filter-label">Select Criteria to Map</label>
                <v-autocomplete
                  v-model="selectedCriteriaIds"
                  :items="criteriaOptions"
                  item-text="text"
                  item-value="value"
                  placeholder="Select criteria..."
                  multiple
                  chips
                  clearable
                  deletable-chips
                  outlined
                  dense
                  hide-details
                  class="premium-select"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="text-right pt-6">
                <v-btn
                  color="primary"
                  :loading="savingMapping"
                  @click="saveCriteriaMapping"
                  medium
                  rounded
                  class="filter-btn btn-search white--text"
                >
                  Save Mapping
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-expand-transition>

        <v-row wrap>
          <v-col cols="12">
            <v-data-table
              :headers="dialogTableHeaders"
              :items="mappedCriteriaList"
              :loading="loadingMappedCriteria"
              class="premium-table"
              dense
              no-data-text="No criteria mapped for this award type."
            >
              <template v-slot:item.CriteriaStatusTxt="{ item }">
                <v-chip
                  small
                  class="font-weight-bold status-chip"
                  :color="
                    item.CriteriaStatus === 1
                      ? 'rgba(76, 175, 80, 0.1)'
                      : 'rgba(255, 152, 0, 0.1)'
                  "
                  :text-color="
                    item.CriteriaStatus === 1 ? '#2e7d32' : '#e65100'
                  "
                >
                  <v-icon
                    left
                    x-small
                    :color="item.CriteriaStatus === 1 ? '#2e7d32' : '#e65100'"
                  >
                    {{
                      item.CriteriaStatus === 1
                        ? "mdi-check-circle"
                        : "mdi-clock-outline"
                    }}
                  </v-icon>
                  {{ item.CriteriaStatusTxt }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    mapCriteriaPrompt: {
      type: Boolean,
      required: true,
    },
    AwardTypeId: {
      type: [Number, String],
      required: true,
    },
    AwardTypeTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDropdownSection: false,
      selectedCriteriaIds: [],
      criteriaOptions: [],
      mappedCriteriaList: [],
      loadingMappedCriteria: false,
      savingMapping: false,
      dialogTableHeaders: [
        { text: "#", value: "SNo", sortable: false },
        { text: "Criteria Name", value: "CriteriaName" },
        { text: "Field Name", value: "CriteriaFieldName" },
        { text: "Type", value: "CriteriaTypeTxt" },
        { text: "Max Points", value: "CriteriaMaxPoints" },
        { text: "Status", value: "CriteriaStatusTxt" },
      ],
    };
  },
  mounted() {
    this.getMappedCriteriaList();
    this.getCriteriaOptions();
  },
  methods: {
    closePrompt() {
      this.$emit("hideMapCriteriaPrompt");
    },
    getMappedCriteriaList() {
      this.loadingMappedCriteria = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var list_url = server_url + "api/award-criteria-mapping/lists";
      var upload = {
        UserInterface: 1,
        AwardType: this.AwardTypeId,
      };

      const thisIns = this;
      this.$http({
        url: list_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.loadingMappedCriteria = false;
          if (response.data.flag) {
            thisIns.mappedCriteriaList = response.data.records;
            thisIns.selectedCriteriaIds = response.data.records.map(
              (r) => r.CriteriaId
            );
          } else {
            thisIns.mappedCriteriaList = [];
          }
        })
        .catch(function (error) {
          console.log("error fetching mapped criteria", error);
          thisIns.loadingMappedCriteria = false;
        });
    },
    getCriteriaOptions() {
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var options_url = server_url + "api/award-criteria-mapping/options";
      var upload = {
        UserInterface: 1,
      };

      const thisIns = this;
      this.$http({
        url: options_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          if (response.data.flag) {
            thisIns.criteriaOptions = response.data.records;
          } else {
            thisIns.criteriaOptions = [];
          }
        })
        .catch(function (error) {
          console.log("error fetching criteria options", error);
        });
    },
    saveCriteriaMapping() {
      this.savingMapping = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var store_url = server_url + "api/award-criteria-mapping/store";
      var upload = {
        UserInterface: 1,
        AwardType: this.AwardTypeId,
        CriteriaIds: this.selectedCriteriaIds,
      };

      const thisIns = this;
      this.$http({
        url: store_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then(function (response) {
          thisIns.savingMapping = false;
          if (response.data.flag) {
            thisIns.toast("success", response.data.output);
            thisIns.showDropdownSection = false;
            thisIns.getMappedCriteriaList();
          } else {
            thisIns.toast("error", response.data.output);
          }
        })
        .catch(function (error) {
          console.log("error saving criteria mapping", error);
          thisIns.savingMapping = false;
          thisIns.toast("error", "Something went wrong.");
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

.premium-checkout-card {
  font-family: "Outfit", "Plus Jakarta Sans", sans-serif;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 24px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(21, 101, 192, 0.18) !important;
  border: 1px solid rgba(255, 255, 255, 0.7) !important;
}

.checkout-banner {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 50%, #42a5f5 100%);
  padding: 30px 20px;
  text-align: center;
  position: relative;
  overflow: hidden;
  color: white;
}

.banner-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 8px;
}

.banner-subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin-top: 4px;
  margin-bottom: 0;
}

.card-content-area {
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.8) 0%,
    #ffffff 100%
  );
}

.filter-label {
  font-size: 12px;
  font-weight: 700;
  color: #455a64;
  margin-bottom: 6px;
  display: block;
}

/* Autocomplete/Select box rounded controls */
.premium-select >>> .v-input__control > .v-input__slot {
  border-radius: 12px !important;
  border: 1.5px solid rgba(21, 101, 192, 0.1) !important;
  background-color: white !important;
  transition: all 0.3s ease !important;
}

.premium-select >>> .v-input__control > .v-input__slot:hover {
  border-color: rgba(21, 101, 192, 0.35) !important;
}

.premium-select.v-input--is-focused >>> .v-input__control > .v-input__slot {
  border-color: #1565c0 !important;
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.15) !important;
}

/* Action buttons */
.filter-btn {
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.btn-search {
  background: linear-gradient(135deg, #1565c0 0%, #1e88e5 100%) !important;
  box-shadow: 0 6px 20px rgba(21, 101, 192, 0.3) !important;
  border: none !important;
}

.btn-search:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(21, 101, 192, 0.45) !important;
}

.result-count-text {
  font-size: 16px;
  font-weight: 700;
  color: #263238;
}

/* Real premium tables */
.premium-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.premium-table >>> thead > tr > th {
  background-color: rgba(21, 101, 192, 0.04) !important;
  color: #1565c0 !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  border-bottom: 2px solid rgba(21, 101, 192, 0.08) !important;
}

.premium-table >>> tbody > tr {
  transition: background-color 0.2s ease;
}

.premium-table >>> tbody > tr:hover {
  background-color: rgba(21, 101, 192, 0.03) !important;
}

.premium-table >>> tbody > tr > td {
  border-bottom: 1px solid rgba(21, 101, 192, 0.04) !important;
  font-size: 15px !important;
  color: #37474f;
  padding: 12px 16px !important;
}

.status-chip {
  font-weight: bold;
}

/* Decorative background icons */
.deco-icon {
  position: absolute !important;
  z-index: 1;
  pointer-events: none;
}

.icon-card {
  font-size: 110px !important;
  right: 20%;
  top: -20px;
  transform: rotate(15deg);
  animation: floatDeco 12s infinite ease-in-out;
}

/* Animations */
.hero-glow-effect {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 0;
  pointer-events: none;
}

.hero-glow-effect::after {
  content: "";
  position: absolute;
  top: 0;
  left: -50%;
  width: 200%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.15) 30%,
    rgba(255, 255, 255, 0) 60%
  );
  transform: skewX(-25deg);
  animation: shineSweep 6s infinite ease-in-out;
}

.relative-content {
  position: relative;
  z-index: 2;
}

.pulse-animation {
  animation: pulseIcon 3s infinite ease-in-out;
}

@keyframes shineSweep {
  0% {
    left: -120%;
  }
  15%,
  100% {
    left: 120%;
  }
}

@keyframes floatDeco {
  0%,
  100% {
    transform: translateY(0) rotate(15deg) scale(1);
  }
  50% {
    transform: translateY(-12px) rotate(20deg) scale(1.03);
  }
}

@keyframes pulseIcon {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
  }
  50% {
    transform: scale(1.08);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.6));
  }
}
</style>
